import { Col, Progress, Row, Tooltip } from 'antd';
import { Rule } from 'antd/lib/form';
import React, { ReactElement } from 'react';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { EXTENDED_STATUS, MB2Bytes, progress, PROGRESS_LEVEL, UPLOAD_STATUS } from '../../constants/crmConstants';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/HIS_Cross_Remove_Icon.svg';
import { ReactComponent as FileIcon } from '../../../assets/images/svg/HIS_File_Icon.svg';
import { UploadFile } from 'antd/lib/upload/interface';
import { submitAdmission } from '../../../store/actions/fileAction';
import { useDispatch } from 'react-redux';
import { centeredNotification } from '../../../utils/utility';
import { getFileStatus, getFileType } from '../../../utils/fileUploadUtils';
import { formatDocumentUploadedDate } from '../../../modules/crm/inPatient/service/crmUtils';

function NonHisBuddhiMedUploadListItem({ file, key, index, onRemove, fileListLength, newUploads,
  fileLimit, showPreviouslyAddedFiles, fileList, showStatus }: any): ReactElement {
  const dispatch = useDispatch();
  const rules: Rule[] = [];
  const [progress33, progress66, progress100] = progress;

  rules.push({ required: true });
  const { existingRecord, name, status, extendedStatus, fileType = [], uid, uploadedOn, createdDate } = file;
  const onDownload = (aFile: UploadFile): void => {
    const { response } = aFile;
    if (response) {
      const { errorMsg, uploadedDetails, isSuccess } = response;
      if (isSuccess) {
        const { fileGuid, fileName } = uploadedDetails[0];
        centeredNotification(`${fileName} start downloading...`, 'success');
        dispatch(submitAdmission(fileGuid));
      } else {
        centeredNotification(errorMsg);
      }
    }
  };

  let customPercent = 0;
  if (status === UPLOAD_STATUS.uploading) {
    customPercent = progress33;
  } else if (status === UPLOAD_STATUS.done) {
    customPercent = (extendedStatus === EXTENDED_STATUS.verified
      || extendedStatus === EXTENDED_STATUS.uploaded || (!extendedStatus && status === UPLOAD_STATUS.done))
      ? progress100 : progress66;
  }

  const bytesToMB = (sizeInBytes: number): string => {
    const sizeInMB = sizeInBytes / (MB2Bytes);
    // Round to 3 decimal places and format it
    const formattedSizeInMB = sizeInMB?.toFixed(3);

    // Return the formatted size in MB
    return `${formattedSizeInMB} MB`;
  };

  return (
    <div className={`${showStatus ? 'upload-list' : ''} upload-list-HIS`}>
      <Row gutter={GUTTOR_SPACE} className="margin-10">
        <Col md={6} className="padding-18">
          <div className="text-elipsis">
            <FileIcon className="fill-gray v-align-middle" /> &nbsp;
            <span className="His-filename">
              <a onClick={(): void => onDownload(file)} className="His-filename">
                <Tooltip placement="right" title={name?.length > 16 ? name : null} mouseEnterDelay={0.8}>
                  {name}
                </Tooltip>
              </a>
            </span>
          </div>
        </Col>
        <Col md={6} className="His-filesize padding-18">
          {formatDocumentUploadedDate(createdDate || uploadedOn)}
        </Col>
        {
          showStatus ? <Col md={4}>
            <span className="text-primary bold fsize_sm">
              {getFileStatus(status, extendedStatus, existingRecord)}
            </span>
          </Col> :
            <Col md={4} className="His-filesize padding-18">
              {bytesToMB(file?.size) || fileLimit}
            </Col>
        }
        <Col md={1} className="circular-progress padding-18">
          {<Progress type="circle" percent={customPercent} width={20} strokeColor={PROGRESS_LEVEL} />}
        </Col>

        {
          <Col md={4} className="His-filename">
            {
              getFileType(fileType)
            }
          </Col>
        }
        <Col span={2} className="padding-40 Non-His-remove-col">
          {!existingRecord ? <Tooltip title="Remove"><CloseIcon data-testid={`${file.uid}-remove`} className="fill-close v-align-middle mouse-pointer"
            onClick={(): void => onRemove(uid)} /></Tooltip> : null}
        </Col>
      </Row>
    </div>
  );
}

export default NonHisBuddhiMedUploadListItem;
